import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCluster } from '@cast/shared-cluster-context-data-access';

import {
  WORKLOAD_CATEGORIES,
  WORKLOAD_VIEWS,
  type WorkloadCategory,
} from '../../../_constants';
import { buildInventoryWorkloadViewPath } from '../../../navigation';
import {
  AutoscalingListFilterValues,
  makeInventoryWorkloadsAutoscalingListLink,
  makeInventoryWorkloadsComputeListLink,
  makeInventoryWorkloadsNetworkListLink,
} from '../_utils/dashboardListNavigation';

export const useInventoryWorkloadsDashboardNavigation = () => {
  const navigate = useNavigate();
  const { cluster } = useCluster();

  const navigateToAutoscalingList = useCallback(
    (filters: AutoscalingListFilterValues) => {
      navigate(
        makeInventoryWorkloadsAutoscalingListLink({
          clusterId: cluster.id,
          filters,
        })
      );
    },
    [cluster.id, navigate]
  );

  const navigateToComputeList = useCallback(
    (sortBy: string) => {
      navigate(
        makeInventoryWorkloadsComputeListLink({
          clusterId: cluster.id,
          sortBy,
        })
      );
    },
    [cluster.id, navigate]
  );

  const navigateToNetworkList = useCallback(
    (sortBy: string) => {
      navigate(
        makeInventoryWorkloadsNetworkListLink({
          clusterId: cluster.id,
          sortBy,
        })
      );
    },
    [cluster.id, navigate]
  );

  const getWorkloadDashboardPath = useCallback(
    (
      workloadId: string,
      category: WorkloadCategory = WORKLOAD_CATEGORIES.DEFAULT
    ) =>
      buildInventoryWorkloadViewPath({
        clusterId: cluster.id,
        workloadId,
        view: WORKLOAD_VIEWS.DASHBOARD,
        category,
      }),
    [cluster.id]
  );

  return {
    navigateToAutoscalingList,
    navigateToComputeList,
    navigateToNetworkList,
    getWorkloadDashboardPath,
  };
};
